import {
  Box,
  Button,
  Link,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

const NUMERIC_QTY = /^\d*\.?\d*$/;

export default function QuantityPicker(props) {
  const { value, disabled, panelOnly } = props;

  const [text, setText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setText("");
  };

  const handleChange = (val) => {
    props.onChange(val);
    if (!panelOnly) {
      handleClose();
    }
  };

  const handleTextChange = (e) => {
    const next = e.target.value;
    if (NUMERIC_QTY.test(next)) {
      setText(next);
    }
  };

  const handleSave = () => {
    if (text === "" || !Number.isFinite(+text) || +text < 0) {
      return;
    }
    handleChange(+text);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const presetValues = [1, 2, 3, 4, 6, 12, 18, 24, 36, 48, 60, 72];

  const panel = (
    <Box p={2} sx={{ maxWidth: "360px", backgroundColor: "#333" }}>
      <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {presetValues.map((o) => (
          <Link
            key={o}
            underline="none"
            sx={{ color: "inherit", cursor: "pointer" }}
            onClick={() => handleChange(o)}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "72px",
                width: "72px",
                borderRadius: "36px",
                backgroundColor: "#000",
                color: "#FFF",
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              {o}
            </Box>
          </Link>
        ))}
      </Box>
      <Box mt={2}>
        <TextField
          fullWidth
          value={text}
          onChange={handleTextChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSave();
            }
          }}
          inputMode="decimal"
          variant="filled"
          placeholder="Quantity"
          disabled={disabled}
          sx={{
            "& .MuiFilledInput-root": {
              backgroundColor: "#999",
              "&.Mui-focused": {
                backgroundColor: "#CCC",
              },
              "&:hover": {
                backgroundColor: "#CCC",
              },
            },
            "& .MuiInputLabel-root": {
              color: "#000",
            },
            ".MuiInputBase-input": {
              fontSize: "2rem",
              paddingTop: "8px",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleSave}>Save</Button>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );

  if (panelOnly) {
    return panel;
  }

  return (
    <Box>
      <Box>
        <Link
          sx={{ color: "inherit", cursor: "pointer" }}
          underline="none"
          aria-describedby={id}
          onClick={handleClick}
        >
          <Box
            sx={{
              minWidth: "4rem",
              height: "56px",
              backgroundColor: "#FFF",
              borderTopLeftRadius: "4px",
              borderTopRightRadius: "4px",
              borderBottom: "1px solid #999",
              position: "relative",
              paddingTop: "12px",
            }}
          >
            <Typography
              variant="overline"
              sx={{
                position: "absolute",
                top: "2px",
                left: "4px",
                fontSize: "10px",
                lineHeight: 1,
              }}
            >
              QTY
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: "26px",
              }}
            >
              {value}
            </Box>
          </Box>
        </Link>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {panel}
      </Popover>
    </Box>
  );
}
